const state = {
  recipients: null
};

const getters = {
  recipients: state => state.recipients
};

const mutations = {
  SET_USERS: (state, users) => {
    if (typeof users === "string") state.recipients = [users]
    else state.recipients = users;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}